//export const LOCAL_URL="http://localhost/";
export const LOCAL_URL="https://tdcp.gop.pk/";

//https://tdcp.gop.pk/